import React, { Component } from "react";
import HeaderPersistentBar from "./HeaderPersistentBar";
import DataContainer from "components/utility/data-container/DataContainer";

class HeaderBottomPersistentBar extends Component {
	render() {
		return (
			<DataContainer data="bottomPersistentBar">
				<HeaderPersistentBar
					color="berry"
					type="bottom"
					dataset={
						process.env.NODE_ENV === "development"
							? { unauthenticated: "true", withoutLine: "true" }
							: this.props.dataset
					}
				/>
			</DataContainer>
		);
	}
}

export default HeaderBottomPersistentBar;
